import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLImage } from '../SMLImage';
import styles from './PlaylistImageMosaic.module.scss';

interface PlaylistImageMosaicProps {
  trackImageUrls: string[];
  fallbackImageUrl: string | null;
  name: string;
  size: number;
}

const PlaylistImageMosaicComponent: React.FC<PlaylistImageMosaicProps> = ({
  trackImageUrls,
  fallbackImageUrl,
  name,
  size,
}) => {
  if (trackImageUrls.length >= 4) {
    const halfSize = size / 2;
    return (
      <div className={styles.mosaic} style={{ width: size, height: size }}>
        {trackImageUrls.slice(0, 4).map((url, index) => (
          <SMLImage
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            src={url}
            alt={name}
            width={halfSize}
            makeSquareFit
            className={styles.mosaicImage}
            style={{ width: halfSize, height: halfSize }}
          />
        ))}
      </div>
    );
  }

  return (
    <SMLImage
      src={trackImageUrls[0] ?? fallbackImageUrl}
      alt={name}
      width={size}
      makeSquareFit
      className="rounded-2"
      style={{ width: size, height: size, flexShrink: 0 }}
    />
  );
};

export const PlaylistImageMosaic = TypedMemo(PlaylistImageMosaicComponent);
